import initialState from 'reducers/productCategories/initialState';

const productCategories = (state = initialState, action = null) => {
  return state;
};

export default productCategories;
